import React from 'react'
import SvgWrapper from '../SvgWrapper'
import type { IllustrationProps } from './types'

const TeamworkWhiteboardIllustration: React.FC<IllustrationProps> = ({ width = 160, height = 102 }) => (
  <SvgWrapper height={height} width={width} viewBox="0 0 160 102" fill="none">
    <path
      d="M21.033 5.242A5.242 5.242 0 0 1 26.274 0h128.418a5.242 5.242 0 0 1 5.242 5.242v66.83a5.242 5.242 0 0 1-5.242 5.24H26.274a5.242 5.242 0 0 1-5.241-5.24V5.241Z"
      fill="#fff"
    />
    <path
      d="M155.847 0H25.297a4.085 4.085 0 0 0-2.888 1.2 4.105 4.105 0 0 0-1.198 2.896v69.038a4.105 4.105 0 0 0 1.198 2.895 4.085 4.085 0 0 0 2.888 1.2h130.55a4.084 4.084 0 0 0 2.888-1.2 4.104 4.104 0 0 0 1.198-2.895V4.096a4.104 4.104 0 0 0-1.198-2.895A4.085 4.085 0 0 0 155.847 0Zm3.697 73.134a3.71 3.71 0 0 1-1.084 2.62 3.694 3.694 0 0 1-2.613 1.086H25.297c-.98-.001-1.92-.392-2.613-1.086a3.713 3.713 0 0 1-1.084-2.62V4.096c.001-.983.39-1.925 1.084-2.62A3.696 3.696 0 0 1 25.297.39h130.55c.981 0 1.92.392 2.613 1.086a3.71 3.71 0 0 1 1.084 2.62v69.038Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="M149.427 11.188H31.718a.194.194 0 0 1-.195-.195.195.195 0 0 1 .195-.194h117.709a.194.194 0 0 1 .195.194.193.193 0 0 1-.195.195Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="M64.987 68.844a.194.194 0 0 1-.194-.195V4.485a.195.195 0 0 1 .332-.137.195.195 0 0 1 .057.137V68.65a.195.195 0 0 1-.195.195ZM94.366 68.844a.194.194 0 0 1-.194-.195V4.485a.195.195 0 0 1 .332-.137.195.195 0 0 1 .057.137V68.65a.195.195 0 0 1-.195.195ZM123.745 68.844a.193.193 0 0 1-.194-.195V4.485c0-.051.02-.1.057-.137a.195.195 0 0 1 .332.138v64.163a.195.195 0 0 1-.195.195Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="M46.099 31.319h-7.11a.875.875 0 0 1-.875-.878v-8.41a.88.88 0 0 1 .875-.877h7.11a.876.876 0 0 1 .875.878v8.409a.88.88 0 0 1-.875.878ZM56.216 55.307h-7.11a.876.876 0 0 1-.875-.878v-8.41a.88.88 0 0 1 .875-.877h7.11a.875.875 0 0 1 .875.878v8.409a.88.88 0 0 1-.875.878Z"
      fill="#CACDDA"
    />
    <path
      d="M79.174 36.39h-7.109a.875.875 0 0 1-.876-.878v-8.41a.88.88 0 0 1 .876-.877h7.11a.876.876 0 0 1 .875.877v8.41a.88.88 0 0 1-.876.877Z"
      fill="#FF0080"
    />
    <path
      d="M108.943 27.223h-7.11a.878.878 0 0 1-.875-.878v-8.409a.878.878 0 0 1 .875-.878h7.11a.874.874 0 0 1 .875.878v8.41a.88.88 0 0 1-.875.877ZM136.375 27.223h-7.109a.876.876 0 0 1-.876-.878v-8.409a.88.88 0 0 1 .876-.878h7.109a.876.876 0 0 1 .875.878v8.41a.878.878 0 0 1-.875.877Z"
      fill="#CACDDA"
    />
    <path
      d="M143.379 44.58h-7.109a.876.876 0 0 1-.875-.877v-8.41a.878.878 0 0 1 .875-.877h7.109a.876.876 0 0 1 .876.877v8.41a.88.88 0 0 1-.876.877ZM119.254 41.46h-7.11a.875.875 0 0 1-.875-.878v-8.41a.875.875 0 0 1 .875-.877h7.11a.874.874 0 0 1 .875.878v8.41a.875.875 0 0 1-.875.877ZM39.678 46.725H32.57a.875.875 0 0 1-.875-.877v-8.41a.88.88 0 0 1 .875-.877h7.11a.875.875 0 0 1 .875.877v8.41a.88.88 0 0 1-.876.877Z"
      fill="#FF0080"
    />
    <path
      d="M53.897 7.996h-11.09a.777.777 0 0 1-.778-.78.78.78 0 0 1 .778-.78h11.09a.777.777 0 0 1 .778.78.78.78 0 0 1-.778.78ZM85.222 7.996h-11.09a.777.777 0 0 1-.778-.78.781.781 0 0 1 .778-.78h11.09a.777.777 0 0 1 .779.78.78.78 0 0 1-.779.78ZM114.601 7.996h-11.09a.777.777 0 0 1-.778-.78.78.78 0 0 1 .778-.78h11.09a.777.777 0 0 1 .778.78.78.78 0 0 1-.778.78ZM142.034 7.996h-11.09a.777.777 0 0 1-.778-.78.78.78 0 0 1 .778-.78h11.09a.777.777 0 0 1 .778.78.78.78 0 0 1-.778.78Z"
      fill="#FFE0EA"
    />
    <path
      d="M29.058 65.117a1.954 1.954 0 0 1-1.74-1.634 1.966 1.966 0 0 1 .047-.848l-4.987-4.654 2.637-.67 4.904 3.986a1.968 1.968 0 0 1 1.262 2.294 1.972 1.972 0 0 1-2.123 1.526ZM35.945 99.512h2.386l1.134-9.222h-3.52v9.222Z"
      fill="#D7B7A8"
    />
    <path
      d="M42.93 101.732h-7.496v-2.903h4.6c.768 0 1.505.306 2.048.85.543.545.848 1.283.848 2.053Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path d="m19.59 97.786 2.306.615 3.463-8.62-3.402-.907-2.366 8.912Z" fill="#D7B7A8" />
    <path
      d="M25.77 101.733 18.527 99.8l.745-2.806 4.446 1.186a2.897 2.897 0 0 1 1.76 1.35 2.91 2.91 0 0 1 .294 2.203Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="M38.972 97.766h-3.64a.92.92 0 0 1-.92-.837l-2.209-23a.731.731 0 0 0-.655-.657.728.728 0 0 0-.769.518L24.364 95.28a.925.925 0 0 1-1.11.633l-3.385-.848a.922.922 0 0 1-.69-.767.927.927 0 0 1 .019-.362c.055-.216 5.528-21.653 5.575-21.873 1.24-9.16 2.724-11.615 3.52-12.933.067-.11.127-.21.182-.305.068-.118.489-1.296.755-2.06a.936.936 0 0 1 .474-.58c3.349-1.717 7.267-.53 8.388-.124.185.066.345.19.454.354 3.363 5.085 1.713 34.615 1.348 40.484a.928.928 0 0 1-.922.866Z"
      fill="#2E35A8"
    />
    <path
      d="M29.579 39.51a4.784 4.784 0 0 0 4.778-4.79c0-2.646-2.14-4.79-4.778-4.79a4.784 4.784 0 0 0-4.779 4.79c0 2.645 2.14 4.79 4.779 4.79Z"
      fill="#D7B7A8"
    />
    <path
      d="m29.073 57.696-.035-.033c-.064-.063-6.431-6.315-5.607-12.097.352-2.473 2.348-4.053 5.772-4.57a5.27 5.27 0 0 1 3.613.773 5.29 5.29 0 0 1 2.224 2.957l3.385 11.6-9.352 1.37Z"
      fill="#A5A9DA"
    />
    <path
      d="m25.814 62.143-4.537-4.519a2.563 2.563 0 0 1-.677-2.417l2.196-8.955a2.022 2.022 0 0 1 1.75-1.527c.275-.028.552 0 .815.084a2.035 2.035 0 0 1 1.325 2.495l-2.313 7.878 3.74 4.025-2.3 2.936Z"
      fill="#A5A9DA"
    />
    <path
      d="M50.148 46.72a1.96 1.96 0 0 1-2.112 1.11c-.282-.05-.55-.16-.784-.324l-6.056 3.147.268-2.673 5.369-3.33a1.966 1.966 0 0 1 3.421.674c.137.463.099.96-.106 1.397Z"
      fill="#D7B7A8"
    />
    <path
      d="m46.59 48.71-5.904 2.558a2.488 2.488 0 0 1-2.427-.261l-7.508-5.392a2.02 2.02 0 0 1 .956-3.645 2.022 2.022 0 0 1 1.463.416l6.438 5.08 5.117-1.985 1.865 3.23Z"
      fill="#A5A9DA"
    />
    <path
      d="M30.371 36.254c.59-.74 1.691-.78 2.5-1.268 1.062-.64 1.5-2.07 1.158-3.262-.342-1.193-1.35-2.122-2.505-2.567-1.156-.445-2.442-.45-3.661-.235-1.816.32-3.603 1.169-4.71 2.646-1.107 1.477-1.389 3.64-.385 5.19.46.712 1.173 1.3 1.357 2.13.241 1.087-.52 2.137-1.336 2.895-.93.863-1.995 1.586-2.81 2.559-.814.973-1.357 2.302-.985 3.517.311 1.017 1.217 1.767 2.21 2.142.994.375 2.075.43 3.137.45 1.03.02 2.125-.005 2.993-.562.93-.596 1.426-1.727 1.463-2.833.036-1.105-.332-2.188-.826-3.178-.294-.59-.637-1.16-.832-1.79-.196-.63-.23-1.344.083-1.924.33-.609.996-.976 1.674-1.11l.112-.019a1.437 1.437 0 0 0 1.217-1.103c.044-.19.049-.387.015-.58-.077-.431-.07-.845.131-1.098Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path d="M94.085 99.716h-2.386l-1.135-9.222h3.52v9.222Z" fill="#604134" />
    <path
      d="M89.996 99.033h4.6v2.904H87.1a2.913 2.913 0 0 1 .848-2.053 2.897 2.897 0 0 1 2.048-.85Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path d="m111.392 97.008-2.169.993-4.856-7.916 3.203-1.466 3.822 8.39Z" fill="#604134" />
    <path
      d="m107.389 98.09 4.185-1.916 1.203 2.64-6.819 3.122a2.911 2.911 0 0 1 .515-3.184c.259-.28.57-.504.916-.663Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="M104.445 68.62a1.957 1.957 0 0 0 .637-2.303 1.95 1.95 0 0 0-.481-.7l2.804-6.377-3.562.606-2.116 5.963a1.975 1.975 0 0 0 .113 2.616 1.964 1.964 0 0 0 2.605.196Z"
      fill="#604134"
    />
    <path
      d="M93.933 97.285h-2.279a.877.877 0 0 1-.873-.814l-1.243-33.264a.88.88 0 0 1 .959-.937l13.178 1.403a.875.875 0 0 1 .791.857l.276 14.673c.001.08.017.158.045.233l5.406 14.052a.881.881 0 0 1-.22.958.876.876 0 0 1-.294.18l-2.309.854a.875.875 0 0 1-1.081-.422l-6.641-12.944a.877.877 0 0 1-.079-.223l-1.134-5.479a.683.683 0 0 0-1.132-.36.682.682 0 0 0-.212.421l-2.288 20.034a.878.878 0 0 1-.87.778Z"
      fill="#2E35A8"
    />
    <path
      d="M95.067 37.199a4.784 4.784 0 0 0 4.779-4.79c0-2.646-2.14-4.79-4.779-4.79a4.784 4.784 0 0 0-4.778 4.79c0 2.645 2.139 4.79 4.778 4.79Z"
      fill="#604134"
    />
    <path
      d="M98.345 66.249a17.027 17.027 0 0 1-9.12-2.77l-.046-.031.004-.057 1.828-21.339a3.01 3.01 0 0 1 .908-1.904 2.997 2.997 0 0 1 1.933-.838c2.368-.11 5.55.029 7.254 1.3 2.574 1.922 3.815 4.816 3.404 7.94-.852 6.479.113 15.218.226 16.193l.008.07-.064.03a15.004 15.004 0 0 1-6.335 1.406Z"
      fill="#A5A9DA"
    />
    <path
      d="M104.714 64.78a.971.971 0 0 1-.716-.317l-1.045-1.143a.982.982 0 0 1-.216-.935l2.383-8.087-3.626-7.634a1.721 1.721 0 0 1 1.33-2.443 1.71 1.71 0 0 1 1.726.89l4.922 8.004c.2.325.317.694.341 1.075.025.38-.044.762-.201 1.11l-4.01 8.905a.972.972 0 0 1-.888.574Z"
      fill="#A5A9DA"
    />
    <path
      d="M71.031 49.332a1.954 1.954 0 0 0 2.918-.698l6.895.897-1.584-3.255-6.305-.352a1.963 1.963 0 0 0-2.472.847 1.976 1.976 0 0 0 .548 2.561Z"
      fill="#604134"
    />
    <path
      d="M86.228 51.11c-.12 0-.24-.009-.359-.025l-10.847-1.508a1.077 1.077 0 0 1-.889-.769 1.09 1.09 0 0 1 .112-.864l.898-1.492a1.087 1.087 0 0 1 .925-.524h.002l9.454.011 7.062-6.341a1.909 1.909 0 0 1 3.03.658 1.922 1.922 0 0 1-.407 2.133l-7.047 7.856a2.6 2.6 0 0 1-1.934.865Z"
      fill="#A5A9DA"
    />
    <path
      d="M95.61 36.67c.437-1.013.807-2.362-.03-3.078-.486-.416-1.186-.416-1.823-.468-1.793-.146-3.64-.973-4.516-2.548-.876-1.575-.387-3.917 1.267-4.627 1.115-.48 2.392-.153 3.56.178l3.502.996c1.041.296 2.134.622 2.884 1.405 1.195 1.247 1.105 3.357.156 4.8-.949 1.445-2.379 2.952-4.015 3.5l-.984-.158ZM143.942 102H.299a.245.245 0 0 1-.09-.017.233.233 0 0 1-.125-.304.242.242 0 0 1 .05-.076.247.247 0 0 1 .076-.05.245.245 0 0 1 .089-.017h143.643c.031 0 .061.006.089.017a.24.24 0 0 1 .126.126.243.243 0 0 1 0 .178.227.227 0 0 1-.051.075.227.227 0 0 1-.164.068Z"
      fill="#020537"
      fillOpacity=".87"
    />
  </SvgWrapper>
)

export default TeamworkWhiteboardIllustration
